import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import NewIcon from '@mui/icons-material/Add';
import { Skeleton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { addTrainingsItem, deleteTrainingsItem, getTrainings, updateTrainingsItem } from '../../../../actions/cv';
import TitledSection from '../../../common/TitledSection/TitledSection';
import CVBaseItem from '../../../common/CVBaseItem/CVBaseItem';
import classes from './scss/trainings.module.scss';
import AddEditCVRecord from '../../../common/ModalWindows/AddEditCVRecord';
import ValidationErrorLabel from '../../../common/ValidationErrorLabel/ValidationErrorLabel';
import colors from '../../../../scss/colors';
import { usePrevious } from '../../../../utils/hooks';

function TrainingsAndCertificates() {
  const dispatch = useDispatch();
  const trainingsItems = useSelector((state) => state.cv?.trainings?.response);
  const pending = useSelector((state) => state.cv?.updatingPending);

  const prevPending = usePrevious(pending);

  const [openAddWindow, setAddWindow] = React.useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getTrainings());
  }, []);

  const deleteHandler = (id) => {
    dispatch(deleteTrainingsItem(id));
  };

  const addTraining = async (training) => {
    dispatch(
      addTrainingsItem({
        CertificationType: training.type,
        CertificationId: training.certId,
        ValidUntil: training.valid ? dateFormat(training.valid, 'isoDate') : null,
        StartDate: null,
        EndDate: null
      })
    );
  };

  const updateTraining = async (training) => {
    dispatch(
      updateTrainingsItem({
        Id: training.id,
        CertificationType: training.type,
        CertificationId: training.certId,
        ValidUntil: training.valid ? dateFormat(training.valid, 'isoDate') : null,
        StartDate: null,
        EndDate: null
      })
    );
  };

  useEffect(() => {
    if (prevPending === true && pending === false) {
      setAddWindow(false);
    }
  }, [pending]);

  return (
    <TitledSection
      title={t('profile.builder.details.training')}
      actions={
        <div className={classes.actionsWrapper}>
          <div className={classes.actionLabel}>
            <span>{t('common.general.save')}</span> <CheckIcon fontSize="8px" />
          </div>
          <NewIcon role="button" className={classes.action} onClick={() => setAddWindow(true)} />
        </div>
      }
    >
      <div className={classes.trainingsList}>
        {openAddWindow && (
          <AddEditCVRecord
            open
            closeHandler={() => setAddWindow(false)}
            editeMode={false}
            confirmHandler={addTraining}
            block="trainings"
            shouldImmediatelySave
            pending={pending}
          />
        )}
        {trainingsItems?.length === 0 && (
          <ValidationErrorLabel message={t('dashboard.jobs.emptylist.notraining')} color={colors.NAVY_BLUE} />
        )}
        {trainingsItems ? (
          trainingsItems?.map((item) => (
            <CVBaseItem
              key={item?.Id || new Date()}
              item={item}
              block="trainings"
              deleteItem={() => deleteHandler(item?.Id)}
              editItem={updateTraining}
              shouldImmediatelySave
              pending={pending}
            />
          ))
        ) : (
          <Skeleton animation="wave" width="100%" />
        )}
      </div>
    </TitledSection>
  );
}

export default TrainingsAndCertificates;
